/* eslint-disable react/jsx-key */
/* eslint-disable no-irregular-whitespace */
import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
import { ContentData } from 'components/cases/common/Interview/fragments/type'
gsap.registerPlugin(ScrollTrigger)

const sectionTitle: { title: string; sub_title: string } = {
  title: 'Interview',
  sub_title: 'インタビュー',
}

const contentData: ContentData[][] = [
  [
    {
      type: 'sectionTitle',
      text: '過去のコンペでアイスリーデザインの提案が群を抜いていた',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/gurutto-ai/Interview_1.webp',
      alt: 'インタビュー写真',
      text: '左から、アート引越センター執行役員の田代憲さん、エリア統括ブロック長の小林直人さん、畠山菜織さん、アイスリーデザインの吉澤、久保',
    },
    {
      type: 'textBox',
      texts: ['―― 本プロジェクト開始の背景を教えてください。'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '田代さん',
      texts: [
        '引越はこれまで、当社が創業間もなく編み出した家財ごとにおよその物量を定めて積算する見積り方法と、担当者が長年培ってきた経験から、お客様のご家財を目で見て物量を算出してきました。ただ、見積り作業は人によって行われるため、同じ家財や同じお客様の家でも、行う人によって多少なりとも結果が異なることは避けられませんし、今は家財も多様化しており、物量を一目で把握するまでには営業担当者の習熟が必要という状況でもあります。そこで、AI技術を使用することで、今まで以上に誤差のない正確な見積りができるのではないかという仮説を立てました。この仮説に基づき、AIを使ってどのようにして見積りの一貫性を実現できるかという点について、アイスリーデザインさんにご相談させていただきました。',
      ],
    },
    {
      type: 'textBox',
      texts: [
        '―― 本プロジェクトのパートナー企業として、アイスリーデザインにご依頼いただいた理由を教えていただけますか？',
      ],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '田代さん',
      texts: [
        'もともと別のシステム開発のためにコンペを実施した際、アイスリーデザインさんの既出のシステムの流用ではなくオーダーメイド前提の提案が群を抜いて優れていました。我々がDX化を進める中で、初めてアルゴリズムを活用したシステムを作ってくれたのがアイスリーデザインさんだったんです。そこで、今回の話が持ち上がったとき、AIを使って物量の積算ができないかという相談を最初に持ちかけました。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '言語化が難しい部分も、現場を見て深く理解してくれた',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/gurutto-ai/Interview_2.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: [
        '―― 「AIを使って物量の積算をする」というアイデアがどのように進化して、現在の形になっていったのでしょうか？ 開発プロセスについて詳しくお聞かせください。',
      ],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '田代さん',
      texts: [
        '我々はデジタルの専門家ではないので、最初は「動画を撮影したら自動的に物量を積算できるようにならないか」といった夢のような話をしていました。そこから具体的な解決策が見つかるまで紆余曲折があり、当初は動画から3Dモデルを生成する予定でしたが、プロジェクトの途中で3Dスキャナーの技術が登場し、アイスリーデザインさんから「この技術を使えば実現できるのではないか」と提案を受け、「じゃあやってみようか」と決断しました。',
        'こうした技術の根本的な転換は、これまでのアート引越センターのシステム開発では考えられないことでした。従来のやり方にこだわらず思い切った決断ができたのは、このプロジェクトが実験的な要素も含んでいたからだと思います。',
      ],
    },
    {
      type: 'textBox',
      texts: ['――実際にアイスリーデザインとプロジェクトを進められた印象はいかがでしたか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '畠山さん',
      texts: [
        'アイスリーデザインさんに依頼してよかったと思うのは、実際に私たちのオペレーションの現場に足を運んでくださったことです。お客様とどのようにコンタクトを取って引っ越しの成約に至るかという流れを理解するために、コールセンターにも訪問し、見積りの出し方を一緒に考えていただきました。このような行動が信頼に繋がり、アイスリーデザインさんに頼んでよかったと強く感じました。',
      ],
    },
    {
      type: 'greyBox',
      name: '田代さん',
      texts: [
        '引っ越し業務というのは本当に複雑で、形のあるものを単純に売るわけではなく、お客様の生活空間にどう関わるかが求められます。そのため、ライフスタイルに合わせた梱包資材のご用意など、現場の判断にも経験や感覚が非常に重要です。しかし、それを言語化して伝えるのは困難です。そのためアイスリーデザインさんに「とりあえず実際に見積りしている様子を見てください」とお願いしたら、すぐに対応してくれました。このフットワークの軽さには本当に感心しましたし、現場を深く理解しようとする姿勢を強く感じました。',
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/gurutto-ai/Interview_3.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'greyBox',
      name: '田代さん',
      texts: [
        'また、ある程度デザインが決まってトップに見せた時に、「アートらしくない」と指摘されたのですが、アイスリーデザインさんは「アートさんらしさではなく、一般ユーザーが使いやすいことを重視しています」と即答されました。長く勤めていますが、トップにここまで意見をはっきり述べた取引先は初めてで感心しました。',
      ],
    },
    {
      type: 'greyBox',
      name: '久保',
      texts: [
        'クライアント様の希望通りに作ることも重要ですが、我々は、エンドユーザーが本当に使いやすいかを第一に考えています。エンジニアだけでなく、デザインやプロジェクトの進行に関わる全てのメンバーがエンドユーザーの視点を意識することが我々のポリシーです。エンドユーザーに近い視点でサービスを育てる専門部署もあり、協力しながら、エンジニアとしても常により良いものを目指しています。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: 'アプリ名指しでの高評価、作業スタッフからも絶賛の声',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/gurutto-ai/Interview_4.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['―― ローンチしたプロダクトの評判はいかがでしょうか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '田代さん',
      texts: [
        '一番嬉しかったのは、お引越しをご利用いただいたお客様すべてにアンケートを取らせていただいている中で、引っ越しサービスそのものではなく、AIアプリに対する評価が返ってきたことです。これを見た時には、この取り組みは間違っていなかったと実感できました。',
        'また、最初の1か月はご利用いただいたお客様全員に本社から電話でヒアリングを行い、評価を集めていました。印象的だったのは、エンジニアをされているお客様から「とうとうここまで来ましたか」と高評価のコメントをいただいたことです。技術のプロの方からそう言っていただけたのは本当に嬉しかったですね。',
      ],
    },
    {
      type: 'textBox',
      texts: ['――社内での評判はいかがでしたか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '田代さん',
      texts: [
        '3Dモデルを通して実際の空間が把握できる点が非常に好評です。これまでは情報が紙面上でしか伝わらず、見積り担当者から作業スタッフに伝わる情報も活字ベース。例えば「冷蔵庫大が1個、テレビ中が1個」といったものでした。しかし、3Dモデルで事前にお客様のお宅の様子が視覚的に伝わることで、作業スタッフは「今日の引っ越しはこれなんだ」と一目で理解できるようになりました。これにより、引越作業での準備も格段にスムーズになり、例えば「このお客様にはシューズケースを多めに持っていこう」といった判断がしやすくなりました。運用としてはまだトライアルの段階ですが、作業スタッフからも絶賛をいただいています。',
      ],
    },
    {
      type: 'textBox',
      texts: ['――数値的な成果についても、出ているものがあれば教えていただけますか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '田代さん',
      texts: [
        'ダウンロードしたお客様が実際に利用し、申し込みなどのアクションを起こした割合が他の比較サイトや一般的なインターネット集客と比べても非常に高く推移しています。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '総合ライフサポート事業として、お客様の生活全体をサポートできるように',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/gurutto-ai/Interview_5.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['―― 今後の「ぐるっとAI見積り」、またアート引越センターさんの展望について伺えますか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '小林さん',
      texts: [
        '現在は主に単身引越しのお客様を対象としていますが、将来的には家族引越しも含め、見積りの際にタブレットで撮影して即座に物量が算出されるような形にしたいです。時間の短縮やお客様の信頼向上に繋がると考えていますし、さらに将来的にはトラックの配車業務もAI化していきたいと思っています。今は人の手で行っている配車作業もAI化することで、より正確なサービスが提供できるのではないかと期待しています。',
      ],
    },
    {
      type: 'greyBox',
      name: '田代さん',
      texts: [
        '年間で約100万件のお見積りを行っていますが、その多くが実際に営業担当者が車で訪問して見積りを行っています。将来的には、このAIの仕組みを活用することにより、車での訪問数を減らすことが可能となり、ひいてはCO2削減にも繋がるため、SDGsの観点からも利用を促進していきたいと思っています。また、引っ越しのお客様にとって、単に見積りをするだけではなく、この情報をさまざまなサービスに展開していき、新生活をより良いものにしていくコンテンツとして確立したいと考えています。お客様から頼りにされるような仕組みを目指していきたいですね。',
      ],
    },
  ],
]

const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>()
  const image = useRef<HTMLImageElement>()
  const text_container = useRef<HTMLDivElement>()
  // const container = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from(image.current, tweenVars, 0.2)
    timeline.from(text_container.current, tweenVars, 0.4)

    ScrollTrigger.create({
      animation: timeline,
      trigger: wrapper.current,
      start: 'top-=100 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
